import { VECTILES_URL } from '@hcs/urls';

export const VECTILES_TILES_URLS = `${VECTILES_URL}/tiles`;
export const HC_MAP_TRANSITION_DURATION_DEFAULT = 800;
export const MAPBOX_KEY =
  'pk.eyJ1IjoibWF0dC1oYyIsImEiOiJ4ZHRkby1jIn0.6AE5Ob825Mlcaf_lIU66eA';
